import { formatExpiryDate } from '@/components/card/card-details/getDetails';
import { Format } from '@/domain/app';
import { KortbetjeningText } from '@/hooks/use-text';
import { formatAmount } from '@/utils/text-format-utils';

import { BalanceType, CreditCard, CreditCardAccount, KredittbankenCardProduct } from '@generated-types';

export const getKbCreditCardDetails = (card: CreditCard, text: KortbetjeningText, account: CreditCardAccount) => {
    const expectedBalance = account.balances.find((balance) => balance.type === BalanceType.EXPECTED)?.amount || 0;

    return [
        {
            description: text.overviewDetailsCardOwner,
            value: `${card.cardHolder.firstName} ${card.cardHolder.lastName}`,
        },
        {
            description: text.overviewDetailsCardNumber,
            value: Format.cardNumber(Format.cardNumber(card.cardNumber)),
        },
        {
            description: text.overviewDetailsCardType,
            value: [
                KredittbankenCardProduct.KREDITTBANKEN_VISA,
                KredittbankenCardProduct.EIKA_KREDITTKORT,
                KredittbankenCardProduct.EIKA_ANSATT,
            ].includes(card.product.code as KredittbankenCardProduct)
                ? text.overviewDetailsCardTypeCredit
                : text.overviewDetailsCardTypeDebit,
        },
        {
            description: expectedBalance > 0 ? text.overviewDetailsAvailable : text.overviewDetailsUsed,
            value: formatAmount(Math.abs(expectedBalance)),
        },
        account.creditLimit && {
            description: text.overviewDetailsCardLimit,
            value: formatAmount(account.creditLimit),
        },
        {
            description: text.overviewDetailsExpires,
            value: formatExpiryDate(card.expires),
        },
        {
            description: text.overviewDetailsInnbetaling,
            value: Format.accountNumber(account.billingSummary.paymentBankAccountNumber),
        },
        {
            description: text.overviewDetailsKID,
            value: account.billingSummary.kidNumber,
        },
    ].filter((i) => !!i);
};
